const solarium = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33320)">
      <path d="M6.225 5.025L5.1 3.90625L4.21875 4.7875L5.3375 5.90625L6.225 5.025ZM4.5 8.5625H2.625V9.8125H4.5V8.5625ZM10.125 2.34375H8.875V4.1875H10.125V2.34375ZM14.7812 4.7875L13.9 3.90625L12.7812 5.025L13.6625 5.90625L14.7812 4.7875ZM12.775 13.35L13.8938 14.475L14.775 13.5938L13.65 12.475L12.775 13.35ZM14.5 8.5625V9.8125H16.375V8.5625H14.5ZM9.5 5.4375C7.43125 5.4375 5.75 7.11875 5.75 9.1875C5.75 11.2562 7.43125 12.9375 9.5 12.9375C11.5688 12.9375 13.25 11.2562 13.25 9.1875C13.25 7.11875 11.5688 5.4375 9.5 5.4375ZM8.875 16.0313H10.125V14.1875H8.875V16.0313ZM4.21875 13.5875L5.1 14.4688L6.21875 13.3438L5.3375 12.4625L4.21875 13.5875Z" fill="black" />
    </g>
    <path d="M22 14.5L17 19.5M17 19.5H5M17 19.5V22.5M5 19.5V22.5M5 19.5H2" stroke="black" strokeOpacity="0.56" strokeWidth="2"/>
    <defs>
      <clipPath id="clip0_1_33320">
        <rect width="15" height="15" fill="white" transform="translate(2 2)"/>
      </clipPath>
    </defs>
  </svg>
);
export default solarium;
